<!-- ngbDropdown gives us click-outside-to-close for free -->
<div class="time-picker" ngbDropdown #dd="ngbDropdown" [autoClose]="'outside'"
    (openChange)="$event ? null : onClosed()">

    <div class="time-picker__field" ngbDropdownToggle [class.is-disabled]="disabled">
        <input type="text" class="form-control" readonly [value]="display"
            [placeholder]="placeholder" [disabled]="disabled">

        <button type="button" class="time-picker__clear" *ngIf="display && !disabled"
            title="Clear" (click)="clear($event)">
            <i class="fa fa-times"></i>
        </button>

        <span class="time-picker__icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39762 14.6024 1.66666 10 1.66666C5.39765 1.66666 1.66669 5.39762 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 5.83334V10L12.5 12.5" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </span>
    </div>

    <div ngbDropdownMenu class="time-picker__menu">
        <ngb-timepicker [ngModel]="time" (ngModelChange)="onTimeChange($event)"
            [meridian]="true" [seconds]="seconds" [spinners]="true" [size]="'small'"
            [ngModelOptions]="{ standalone: true }">
        </ngb-timepicker>
        <div class="time-picker__actions">
            <button type="button" class="btn btn-sm btn-outline-dark" (click)="setNow()">Now</button>
            <button type="button" class="btn btn-sm btn-orange" (click)="dd.close()">Done</button>
        </div>
    </div>
</div>
